// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__1n1lL","label":"LabeledBox_label__3Ywny"};